import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getBulletinDetails } from "../api/getBulletinDetails";

export const useBulletinDetailsQuery = (bulletinId: string) => {
  return useQuery({
    queryKey: ["bulletin", bulletinId],
    queryFn: async () => {
      return await getBulletinDetails(bulletinId);
    },
    enabled: !!bulletinId,
  });
};

export const invalidateBulletinDetailsQuery = (bulletinId: string) => {
  return queryClient.invalidateQueries({
    queryKey: ["bulletin", bulletinId],
  });
};
